import DisclaimerMessage from "../DisclaimerMessage/DisclaimerMessage";

const StateUnqualified = () => {
  return (
    <DisclaimerMessage
      header={"Unfortunately, HolaVida isn’t available in your state yet."}
      content={
        "We're unable to provide medical care at this time. HolaVida will notify you once we're available in your state."
      }
    />
  );
};

export default StateUnqualified;
